function API_URL() {
    if (process.env.NODE_ENV === "development") {
        return "https://dev-www.addcampus.com";
    } else {
        return "https://addcampus.com";
    }
}

function ADDY_URL(){
    if (process.env.NODE_ENV === "development") {
        return "https://dev-addy.addcampus.com";
    } else {
        return "https://addy.addcampus.com";
    }
}

function calResult(sum_point) {
    let result_id;
    if (0 <= sum_point && 4 >= sum_point) {
        result_id = 0;
    } else if (5 <= sum_point && 7 >= sum_point) {
        result_id = 1;
    } else if (8 <= sum_point && 9 >= sum_point) {
        result_id = 2;
    } else if (10 === sum_point) {
        result_id = 3;
    } else if (11 <= sum_point && 12 >= sum_point) {
        result_id = 4;
    } else if (13 <= sum_point && 15 >= sum_point) {
        result_id = 5;
    } else {
        result_id = 6;
    }
    return result_id;
}

module.exports = {
    API_URL: API_URL(),
    ADDY_URL:ADDY_URL(),
    calResult:calResult,
}
